import baseOptions from './baseOptions';
import buildDrillDown from '../../../buildDrillDown';
import abbreviateNumber from '../../../utils/abbreviateNumber';

// Radar (spider) plots one or more metrics across the members of a dimension on
// a polar axis. It reuses the categories x series data produced by toBarSeries.
// Requires the highcharts-more module (already registered in Chart.tsx).
const radar = ({
  title,
  openMenu,
  groupField,
  fieldType,
  chartDef,
  fontSize,
  formatMetric,
  showLegend,
  dateScope,
}) => ({
  ...baseOptions(formatMetric),
  chart: {
    ...baseOptions(formatMetric).chart,
    polar: true,
    type: 'line',
    marginTop: 24,
  },
  title: {
    ...baseOptions(formatMetric).title,
    text: title,
  },
  legend: {
    ...baseOptions(formatMetric).legend,
    enabled: showLegend,
  },
  pane: {
    size: '80%',
  },
  xAxis: {
    tickmarkPlacement: 'on',
    lineWidth: 0,
    labels: {
      style: {
        fontSize,
      },
    },
  },
  yAxis: {
    gridLineInterpolation: 'polygon',
    lineWidth: 0,
    min: 0,
    labels: {
      style: {
        fontSize,
      },
      formatter: function () {
        const abbreviated = abbreviateNumber(this.value);
        if (abbreviated) {
          return abbreviated.abbreviated.toLowerCase();
        }
        return this.axis.defaultLabelFormatter.call(this);
      },
    },
  },
  plotOptions: {
    series: {
      marker: {
        enabled: true,
        radius: 3,
      },
      point: {
        events: {
          click: function (e) {
            const selectedIndex = e.point.x;
            const terms = e.point.series.data;
            if (openMenu) {
              const { metricIds } = this.series.userOptions;
              const selectedTerm = terms.find(
                (t, index) => index === selectedIndex,
              );
              if (!selectedTerm) {
                return;
              }
              openMenu(
                metricIds,
                buildDrillDown(
                  groupField,
                  fieldType,
                  selectedTerm.category,
                  chartDef,
                  dateScope,
                ),
              );
            } else {
              const { onDrillDown } = this.series.userOptions;
              if (!onDrillDown) {
                alert('Coming soon...');
                return;
              }
              const selectedTerm = terms.find(
                (t, index) => index === selectedIndex,
              );
              if (selectedTerm) {
                onDrillDown(
                  selectedTerm.name || selectedTerm.category,
                  e.ctrlKey || e.metaKey,
                );
              }
            }
          },
        },
      },
    },
  },
  tooltip: {
    ...baseOptions(formatMetric).tooltip,
    shared: true,
  },
});

export default radar;
